import { Button, Col, Form, Input, Modal, Radio, Row, Select, Space, Switch, Upload } from "antd";
import Icon from "../../../../assets/icons/icon";
import DividerLine from "../../../../components/lineSplit";
import _t from "../../../../lang/translate";
import DateSelect from "../../../../components/form/dateSelect";
import InputNum from "../../../../components/form/inputNum";
import InputPrice from "../../../../components/form/inputPrice";
import { UploadFile } from "antd/lib/upload/interface";
import { useEffect, useState } from "react";
import DocumentsUpload from "../../../../components/documentsUpload";
import useMotorAtlasOptions from "../../../forms/motorAtlasCatalogMapper/useMotorAtlasOptions";
import { clearDependentFields, ModelBrowserOptions } from "../../../forms/motorAtlasCatalogMapper/util";
import MotorAtlasLink from "../../../../components/motorAtlasLink";
import { taxScenarioFileUrl, uploadTaxScenarioFile } from "../../../../services/taxScenarioService";
import { IdType } from "../../../../types/appTypes";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import { accepted } from "../../../../utilities/acceptedFiles";
import { convertToUploadFile } from "../../../../utilities/convertTypes";
const { confirm } = Modal;

export default async function createAdvertAsync(payload: Payload): Promise<AdvertCreationForm | null> {
  const cancelBtnId = `async_modal__modal_cancel_btn`;
  const closeModal = () => document.getElementById(cancelBtnId)?.click();

  return new Promise((resolve, reject) => {
    confirm({
      title: null,
      className: "motor_atlas_catalog_mapper_modal open-modal-wp",
      content: (
        <ModalContent
          submit={(submitPayload) => {
            resolve(submitPayload);
            closeModal();
          }}
          onCancel={closeModal}
          payload={payload}
        />
      ),
      icon: null,
      width: 575,
      maskClosable: true,
      cancelButtonProps: {
        id: cancelBtnId,
        hidden: true,
      },
      okButtonProps: {
        hidden: true,
      },
      okCancel: true,
      onCancel() {
        resolve(null)
      },
    });
  });
}

type AdvertCreationForm = {
  firstRegDate: string;
  type: string;
  make: string;
  model: string;
  subModel: string;
  variant: string;
  motorAtlasId?: string;
  horsePower?: number;
  newPrice?: number | null | undefined;
  mileage: number;
  price: number;
  source: string;
  sellerDealer: string;
  days: number;
  description: string;
  documents: UploadFile[] | undefined,
}
const initValues = {
  "firstRegDate": "2025-10-01T14:33:38.701+02:00",
  "make": "130",
  "model": "085",
  "subModel": "033",
  "variant": "0002DE0014470",
  "motorAtlasId": "011300850330002DE0014470",
  "horsePower": 4320,
  "newPrice": 543000,
  "mileage": 53000,
  "price": 324000,
  "source": "Autoscout",
  "sellerDealer": "foo/bar",
  "days": 28,
  "description": "Foobar beskrivelse",
  "documents": [
    // {
    //   "uid": "rc-upload-1761133574773-20",
    //   "lastModified": 1760448299596,
    //   "name": "udstyrliste-196648-WAUZZZF34N1040891-2025-10-13_14-29-1.pdf",
    //   "size": 37943,
    //   "type": "application/pdf",
    //   "percent": 0,
    //   "originFileObj": {
    //     "uid": "rc-upload-1761133574773-20"
    //   },
    //   "url": "blob:http://localhost:3000/df0d945c-4865-4421-ab39-ca8d3d6a40ca"
    // }
  ]
}
type Payload = {
  taxCaseId: IdType,
  scenarioId?: IdType
}
type ModalContentProps = {
  submit: (submitPayload: AdvertCreationForm) => void;
  onCancel: (errors?: any) => void;
  payload: Payload
}
function ModalContent({ onCancel, submit, payload }: ModalContentProps) {
  const [form] = Form.useForm<AdvertCreationForm>()
  const [creationMethod, setCreationMethod] = useState<"list" | "manual">("list")
  const [useExpandedSearch, setUseExpandedSearch] = useState(false)
  const [loading, setLoading] = useState(false)
  const {
    handleDrillDown,
    loadingOptionsFields,
    options,
  } = useMotorAtlasOptions("select", useExpandedSearch)

  async function handleSubmit(values: AdvertCreationForm) {
    try {
      setLoading(true)
      const uploadedFiles = values?.documents ? await Promise.all(values.documents?.map(file => {
        const formData = new FormData()
        formData.append("file", file.originFileObj as File)
        return uploadTaxScenarioFile(payload.taxCaseId, payload.scenarioId ?? -1, formData)
      })) : []

      const submissionPayload: AdvertCreationForm = {
        ...values,
        type: "Personbil",
        documents: uploadedFiles.map(apiFile => convertToUploadFile(apiFile.data))
      }
      const { make, model, subModel, variant } = values
      if (creationMethod === 'list') {
        submissionPayload.make = options.make?.find(item => item.value === make)?.label ?? "";
        submissionPayload.model = options.model?.find(item => item.value === model)?.label ?? "";
        submissionPayload.subModel = options.subModel?.find(item => item.value === subModel)?.label ?? "";
        submissionPayload.variant = options.variant?.find(item => item.value === variant)?.label ?? "";
      } else {
        submissionPayload.motorAtlasId = undefined
      }

      submit(submissionPayload)

    } catch (error) {

      renderErrorMessage(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleDrillDown({ type: "01" }, "type")
  }, [])

  function handleValuesChange(changedValue: Partial<AdvertCreationForm>, values: AdvertCreationForm) {
    const key = Object.keys(changedValue)[0] as keyof AdvertCreationForm
    let cleaned = values
    if (key) {
      cleaned = clearDependentFields({ ...values, type: "01" }, key)
    }
    form.setFieldsValue(cleaned);
    handleDrillDown(cleaned, key)

    if (creationMethod === 'list') {
      const { make, model, subModel, variant } = values
      const motorAtlasId = `01${make ?? ""}${model ?? ""}${subModel ?? ""}${variant ?? ""}`
      form.setFieldsValue({ motorAtlasId })
    }

  }

  function handleMethodChange(method: string) {
    const { make, model, subModel, variant } = form.getFieldsValue()
    if (method === 'list') {
      const makeValue = options.make?.find(item => item.label === make)?.value;
      const modelValue = options.model?.find(item => item.label === model)?.value;
      const subModelValue = options.subModel?.find(item => item.label === subModel)?.value;
      const variantValue = options.variant?.find(item => item.label === variant)?.value;
      const motorAtlasId = `01${makeValue ?? ""}${modelValue ?? ""}${subModelValue ?? ""}${variantValue ?? ""}`
      form.setFieldsValue({
        make: makeValue,
        model: modelValue,
        subModel: subModelValue,
        variant: variantValue,
        motorAtlasId
      })
    } else {
      const makeLabel = options.make?.find(item => item.value === make)?.label;
      const modelLabel = options.model?.find(item => item.value === model)?.label;
      const subModelLabel = options.subModel?.find(item => item.value === subModel)?.label;
      const variantLabel = options.variant?.find(item => item.value === variant)?.label;
      form.setFieldsValue({
        make: makeLabel,
        model: modelLabel,
        subModel: subModelLabel,
        variant: variantLabel,
      })
    }

    setCreationMethod(method as any)
  }


  return (
    <div className="pl-2 pr-2 pt-1 pb-2">
      <Row className="mb-1" justify="space-between" wrap={false} align="middle">
        <Col>
          <h3>{_t("create_advert_manually")}</h3>
        </Col>
        <Col>
          <Button type="text" onClick={onCancel} icon={<Icon name="close-outline" />} />
        </Col>
      </Row>


      <Form form={form} className="truncate-form-selects"
        onFinish={handleSubmit}
        onValuesChange={handleValuesChange}
        labelAlign="left" colon={false}>
        <Form.Item label={_t("extended_lookup")}>
          <Switch
            checked={useExpandedSearch}
            onChange={setUseExpandedSearch}
          />
        </Form.Item>
        <Form.Item label=" ">
          <Radio.Group
            value={creationMethod}
            onChange={e => handleMethodChange(e.target.value)}
            buttonStyle="solid"
            optionType="button"
            options={[
              { value: "list", label: _t("choose_from_list") },
              { value: "manual", label: _t("manual") },
            ]}
          />
        </Form.Item>



        <Form.Item name="firstRegDate" label={_t("firstRegDate")} rules={[{ required: true }]}>
          <DateSelect placeholder={_t("choose", "firstRegDate")} />
        </Form.Item>

        {creationMethod === 'list'
          ? <ChooseFromList loadingOptionsFields={loadingOptionsFields} options={options} />
          : <ManualVehicleInput />
        }
        <Form.Item hidden name="motorAtlasId">
          <Input />
        </Form.Item>

        {creationMethod === 'manual' && (
          <>
            <Form.Item name="horsePower" label={_t("horse_power")} rules={[{ required: true }]}>
              <InputNum placeholder={_t("input", "horse_power")} />
            </Form.Item>
            <Form.Item name="newPrice" label={_t("eventually", "new_price")}>
              <InputPrice suffix="kr." placeholder={_t("input", "new_price")} />
            </Form.Item>
          </>
        )}
        <DividerLine />

        <Form.Item name="mileage" label={_t("mileage")} rules={[{ required: true }]}>
          <InputNum suffix="km." placeholder={_t("input", "mileage")} />
        </Form.Item>
        <Form.Item name="price" label={_t("price")} rules={[{ required: true }]}>
          <InputPrice suffix="kr." placeholder={_t("input", "price")} />
        </Form.Item>
        <Form.Item name="source" label={_t("source")} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="sellerDealer" label={_t("seller", "dealer", "/")} rules={[{ required: true }]}>
          <Input placeholder={_t("input")} />
        </Form.Item>
        <Form.Item name="days" label={"Liggedage"} rules={[{ required: true }]}>
          <InputNum suffix="dage" placeholder={_t("input", "days")} />
        </Form.Item>

        <Form.Item name="description" label={_t("advert", 'description')} rules={[{ required: true }]}>
          <Input.TextArea rows={4} placeholder={_t("input", "description")} />
        </Form.Item>

        <Form.Item name="documents"
          preserve
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList ?? []}
          help={!payload.scenarioId ? "Gem beregning først" : null}
        >
          <Upload
            showUploadList
            multiple accept={accepted.join(",")}
            listType="text"
            beforeUpload={() => false}
            disabled={!payload.scenarioId}
          >
            <Button icon={<Icon name={"cloud-upload-outline"} />}
              disabled={!payload.scenarioId}

            >{_t("upload")}</Button>
          </Upload>
        </Form.Item>

        <DividerLine fluid />
        <Row justify="end">
          <Col>
            <Space size={"small"}>
              <Button loading={loading} onClick={onCancel}>
                {_t("cancel")}
              </Button>
              <Button loading={loading} type="primary" htmlType="submit">
                {_t("create")}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>


    </div>
  )
}

const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

function ManualVehicleInput() {
  return (
    <>
      <Form.Item name="make" label={_t("brand")} rules={[{ required: true }]}>
        <Input placeholder={_t("input", "brand")} />
      </Form.Item>
      <Form.Item name="model" label={_t("model")} rules={[{ required: true }]}>
        <Input placeholder={_t("input", "model")} />
      </Form.Item>
      <Form.Item name="subModel" label={_t("subModel")} rules={[{ required: true }]}>
        <Input placeholder={_t("input", "subModel")} />
      </Form.Item>
      <Form.Item name="variant" label={_t("variant")} rules={[{ required: true }]}>
        <Input placeholder={_t("input", "variant")} />
      </Form.Item>

    </>
  )
}


type ChooseFromListProps = {
  loadingOptionsFields: Set<keyof ModelBrowserOptions>
  options: ModelBrowserOptions
}
function ChooseFromList({ loadingOptionsFields, options }: ChooseFromListProps) {


  return (
    <>
      <Form.Item label={_t("brand")} name={['make']} rules={[{ required: true }]}>
        <Select loading={loadingOptionsFields.has("make")}
          disabled={!options.make?.length}
          showSearch
          placeholder={_t("choose")}
          optionFilterProp="label"
          dropdownMatchSelectWidth={400}
          allowClear
          options={options.make} />
      </Form.Item>

      <Form.Item label={_t("model")} name={['model']} rules={[{ required: true }]}>
        <Select loading={loadingOptionsFields.has("model")}
          disabled={!options.model?.length}
          showSearch
          placeholder={_t("choose")}
          optionFilterProp="label"
          dropdownMatchSelectWidth={400}
          allowClear
          options={options.model} />
      </Form.Item>
      <Form.Item label={_t("subModel")} name={['subModel']} rules={[{ required: true }]}>
        <Select
          loading={loadingOptionsFields.has("subModel")}
          disabled={!options.subModel?.length}
          showSearch
          placeholder={_t("choose")}
          optionFilterProp="label"
          dropdownMatchSelectWidth={400}
          allowClear
          options={options.subModel} />
      </Form.Item>

      <Form.Item label={_t("variant")} name={['variant']} rules={[{ required: true }]}>
        <Select
          loading={loadingOptionsFields.has("variant")}
          disabled={!options.variant?.length}
          showSearch
          placeholder={_t("choose")}
          optionFilterProp="label"
          dropdownMatchSelectWidth={400}
          allowClear
          options={options.variant} />
      </Form.Item>
      <Form.Item label={_t("DAT", "code", "-")} shouldUpdate={(a, b) => a.motorAtlasId !== b.motorAtlasId}>
        {({ getFieldValue }) => {
          const motorAtlasId = getFieldValue(['motorAtlasId'])
          return (
            <MotorAtlasLink motorAtlasId={motorAtlasId} motorAtlasTab="teknisk" />
          )
        }}
      </Form.Item>
    </>
  )
}
